import React from "react";
import cn from "classnames";
import Slider from "react-slick";
import styles from "./Roadmap.module.sass";
import Icon from "../../../components/Icon";
import ScrollParallax from "../../../components/ScrollParallax";

const items = [
  {
    title: "Provide information as much as possible",
    image: "/images/zova/value-01.jpg",
    image2x: "/images/zova/value-01@2x.jpg",
    content:
      "We need as much information as you can provide. That is: <ol><li>Lifestyle questionnaire</li><li>Tests (A complete blood test is a priority but even without any tests you can still enter the service)</li></ol>",
  },
  {
    title: "Get your personalized report in 48 hours",
    image: "/images/zova/value-02.jpg",
    image2x: "/images/zova/value-02@2x.jpg",
    content:
      "After we get to know you… Our medical team will start on building a full personalized longevity report for you! it includes: <ol><li>Analytics: current state of your health</li><li>Lifestyle adjustment tips: Sleep, Diet, Exercise</li><li>Supplement Regimen</li><li>A full analysis of any lab data you provide us</li><li>Tests that we recommend you take</li></ol>",
  },
  {
    title: "First medical session on your first priority",
    image: "/images/zova/value-03.jpg",
    image2x: "/images/zova/value-03@2x.jpg",
    content:
      "Based on the statistical data we obtain on your different health aspects and your own priority, the <b>first follow-up session will be after you read the first section of your report, your top priority! We will answer your questions, and give you tips for smooth implantation.</b>",
  },
  {
    title: "Join the Zova club",
    image: "/images/zova/value-04.jpg",
    image2x: "/images/zova/value-04@2x.jpg",
    content:
      "Join the club! Zova's clients have communities based on their profiles! With your Zova club you: <ol><li>You are grouped with people with a similar priority and Start implementing your lifestyle adjustments together!</li><li>We set up challenges, hangouts, and specific webinars for you.</li></ol>",
  },
  {
    title: "Second medical session on your second priority",
    image: "/images/zova/value-05.jpg",
    image2x: "/images/zova/value-05@2x.jpg",
    content:
      "At the beginning of your second month with us, You have already started implementing the adjustments related to your top priority! In second session, we will: <ol><li>Discuss what worked and what didn't when implementing your lifestyle adjustments.</li><li>Adjust based on your feedback.</li><li>Give you personalized tips on how to start on the 2nd section of the report.</li></ol>",
  },
  {
    title: "Third medical session on your final priority",
    image: "/images/zova/value-01.jpg",
    image2x: "/images/zova/value-01@2x.jpg",
    content:
      "At the beginning of your third month with us, you can book your third follow-up session with us. The session will be similar to your previous one and will focus on the final priority in your health journey!",
  },
  {
    title: "Ongoing support from your longevity team",
    image: "/images/zova/value-02.jpg",
    image2x: "/images/zova/value-02@2x.jpg",
    content:
      "During these 3 months, our team is always on standby to answer your questions via email! Also, you will receive personalized weekly emails including tips and information which will be useful to you during your journey with us! <b>Together these 3 months will enable us to cover every aspect of your health, step by step and based on your own priorities.</b>",
  },
  {
    title: "What happens at the end of 3 months?",
    image: "/images/zova/value-03.jpg",
    image2x: "/images/zova/value-03@2x.jpg",
    content:
      "After your time with us comes to an end, we will book a fourth medical session with our team for you. <b>During this session, we will:</b> <ol><li>Discuss your feedbacks</li><li>Review your progress in these months</li><li>Answer your questions and give you further tips</li></ol>",
  },
  {
    title: "Taking the service to the next-level",
    image: "/images/zova/value-04.jpg",
    image2x: "/images/zova/value-04@2x.jpg",
    content:
      "What happens if you decide to extend your membership for another 3 months? After you give us as much information as possible (lifestyle questionnaire in comparison mode and further tests), we will use your feedback and results from the past 3 months to craft a second full longevity report for you <b>because at this point we know you even better!</b>",
  },
];

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const Roadmap = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14" />
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 100000,
        settings: "unslick",
      },
    ],
  };

  return (
    <div className={cn("section-pb", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <div className={cn("stage-small", styles.stage)}>Your ZovaLife Journey</div>
          <h2 className={cn("h2", styles.title)}>Longevity, Your Way</h2>
          <div className={styles.info}>
            We're here to make longevity science practical, affordable, and yours. No fancy tests required to start—just real, science-backed steps to live healthier, longer. Here's how it rolls:{" "}
          </div>
        </div>
        <div className={styles.wrap}>
          <Slider
            className={cn("roadmap-slider", styles.slider)}
            {...settings}
          >
            {items.map((x, index) => (
              <ScrollParallax className={styles.item} key={index}>
                <div className={styles.row}>
                  <div className={styles.col}>
                    <div className={styles.details}>
                      <div className={styles.number}>0{index + 1}.</div>
                      <div className={styles.category}>{x.title}</div>
                      <div 
                        className={styles.content}
                        dangerouslySetInnerHTML={{ __html: x.content }}
                      />
                    </div>
                  </div>
                  <div className={styles.col}>
                    <img
                      srcSet={`${x.image2x} 2x`}
                      src={x.image}
                      alt="Lifestyle"
                    />
                  </div>
                </div>
              </ScrollParallax>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
